import React from "react";
import {
  RecentSearchesClear,
  RecentSearchesHeader,
  RecentSearchesItem,
  RecentSearchesItemClear,
  RecentSearchesList,
  RecentSearchesTitle,
  SearchButton,
  SearchContainer,
  SearchIcon,
  SearchInput,
  SearchResult,
  SearchResultItem,
  SearchResultList,
} from "./styles";
import { AssetImageUrl } from "../../../../../assets/imgUrl";
import { getKeywordsAutocomplete } from "../../../../../headerServices/header/header";
import { lsGetItem, lsSetItem } from "../../../../../utils/safeWebStorage";
import langGroup from "../../../../../assets/lang.json";
import getLangKeyValueFun from "../../../../../utils/lang";
import { SEARCH_RESULT } from "../../utils";

const getText = getLangKeyValueFun(langGroup);

interface WebSearchState {
  /** 搜索词 */
  searchText: string;
  /** 搜索结果 */
  searchResults: any[];
  /** 历史搜索 */
  recentSearches: string[];
  /** 是否播放动画 */
  isFlashing: boolean;
}

class WebSearch extends React.Component<{}, WebSearchState> {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      searchResults: [],
      recentSearches: [],
      isFlashing: false,
    };
  }

  componentDidMount() {
    window.addEventListener("click", () => {
      this.setState({
        searchResults: [],
        recentSearches: [],
      });
    });
  }

  onInputKeywords = (e) => {
    this.setState(
      {
        searchText: e.target.value,
      },
      () => {
        if (!this.state.searchText) {
          this.setState({ searchResults: [] });
          return;
        } else {
          this.onSearchKeywords();
          this.setState({
            recentSearches: [],
          });
        }
      }
    );
  };

  onSearchKeywords = () => {
    if (this.state.searchText) {
      getKeywordsAutocomplete({
        method: "vela.keywords.autocomplete.get",
        word: this.state.searchText,
        num: 10,
      })
        .then((res: any) => {
          this.setState({
            searchResults: res?.info?.keywords,
          });
        })
        .catch((err) => console.error(err));
    }
  };

  onStorageLocal = (e: React.MouseEvent, keyword?: string) => {
    e.stopPropagation();
    const { searchText } = this.state;
    const newSearchText = keyword || searchText;
    if (newSearchText) {
      let localStorageList = [];
      try {
        localStorageList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
      } catch (e) {
        localStorageList = [];
      }
      if (!localStorageList.some((i) => i === newSearchText)) {
        localStorageList.unshift(newSearchText);
        lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(localStorageList));
      }
      this.onSearchPage(newSearchText);
    } else {
      this.setState({
        isFlashing: true,
      });
      setTimeout(() => {
        this.setState({
          isFlashing: false,
        });
        this.onShowHideRecentSearch(e, true);
      }, 1000);
    }
  };

  onSearchPage = (keyword: string) => {
    location.href = `${SEARCH_RESULT()}${keyword}`;
  };

  onShowHideRecentSearch = (e: React.MouseEvent, isShow: boolean) => {
    e.stopPropagation();
    if (!this.state.searchText) {
      this.setState({
        recentSearches: isShow
          ? JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || []
          : [],
      });
    }
  };

  onClearLocalStorage = (e: React.MouseEvent, index?: number) => {
    e.stopPropagation();
    let localStorageList = [];
    try {
      localStorageList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
    } catch (e) {
      localStorageList = [];
    }
    if (index >= 0) {
      localStorageList.splice(index, 1);
    } else {
      localStorageList = [];
    }
    lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(localStorageList));
    this.setState({
      recentSearches: localStorageList,
    });
  };

  onEnterPress = (e) => {
    if (e.keyCode === 13) {
      this.onStorageLocal(e);
    }
  };

  /** 是否点击下拉框内非选择区域 */
  onClickNonSelectionArea = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  render() {
    const { searchResults, recentSearches, isFlashing } = this.state;
    return (
      <SearchContainer>
        <SearchInput
          onClick={(e) => this.onShowHideRecentSearch(e, true)}
          onChange={this.onInputKeywords}
          placeholder={"search"}
          className={isFlashing && "ani"}
          onKeyDown={this.onEnterPress}
        />
        <SearchIcon
          src={AssetImageUrl["ic_search@3x.png"]}
          alt="Search"
          style={{ width: "17px", height: "17px" }}
        />
        <SearchButton onClick={(e) => this.onStorageLocal(e)}>
          {getText("Search")}
        </SearchButton>
        <SearchResult
          onClick={this.onClickNonSelectionArea}
          className={(0 in searchResults || 0 in recentSearches) && "isShow"}
        >
          <SearchResultList className={0 in recentSearches && "showSearches"}>
            {0 in searchResults &&
              (searchResults || []).map((item) => (
                <SearchResultItem
                  key={item.position}
                  onClick={(e) => this.onStorageLocal(e, item?.keyword)}
                >
                  {item?.keyword}
                </SearchResultItem>
              ))}
            {0 in recentSearches && (
              <React.Fragment>
                <RecentSearchesHeader>
                  <RecentSearchesTitle>
                    {getText("Recent Searches")}
                  </RecentSearchesTitle>
                  <RecentSearchesClear
                    onClick={(e) => this.onClearLocalStorage(e)}
                  >
                    {getText("Clear All")}
                  </RecentSearchesClear>
                </RecentSearchesHeader>
                <RecentSearchesList>
                  {recentSearches.map((item, index) => (
                    <RecentSearchesItem
                      key={index}
                      onClick={(e) => this.onStorageLocal(e, item)}
                    >
                      <span>{item}</span>
                      <RecentSearchesItemClear
                        onClick={(e) => this.onClearLocalStorage(e, index)}
                      >
                        {getText("Clear")}
                      </RecentSearchesItemClear>
                    </RecentSearchesItem>
                  ))}
                </RecentSearchesList>
              </React.Fragment>
            )}
          </SearchResultList>
        </SearchResult>
      </SearchContainer>
    );
  }
}

export default WebSearch;
